import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getTasks, createTask, updateTask, getClients, getUsers } from "./opsApi";
import { useOpsAuth } from "./OpsAuthContext";
import { Plus } from "lucide-react";

const inp = "w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-[#AC3333]";
const STATES = ["pendiente", "en_curso", "hecho"];
const badge = { pendiente: "bg-slate-500/20 text-slate-300", en_curso: "bg-blue-500/20 text-blue-300", hecho: "bg-emerald-500/20 text-emerald-300" };

export default function OpsTasks() {
  const { user } = useOpsAuth();
  const isSuper = user?.role === "super_admin";
  const [rows, setRows] = useState([]);
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [f, setF] = useState({ client_id: "", title: "", due_date: "", assignee_id: "" });

  const load = () => {
    getTasks().then(setRows).catch(() => {});
    getClients().then(setClients).catch(() => {});
    if (isSuper) getUsers().then(setUsers).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.client_id || !f.title.trim()) { toast.error("Cliente y título requeridos"); return; }
    try { await createTask(f); setF({ ...f, title: "", due_date: "" }); load(); toast.success("Tarea creada"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };
  const setStatus = async (t, status) => { await updateTask(t.id, { status }); load(); };
  const cname = (id) => clients.find((c) => c.id === id)?.name || "—";

  return (
    <div data-testid="ops-tasks">
      <h2 className="mb-5 font-serif text-2xl font-bold text-white">Tareas</h2>
      <div className="mb-6 flex flex-wrap items-end gap-3 rounded-2xl border border-white/10 bg-[#241010] p-4">
        <div className="min-w-[140px] flex-1"><label className="mb-1 block text-xs text-white/50">Cliente</label>
          <select data-testid="ops-task-client" value={f.client_id} onChange={(e) => setF({ ...f, client_id: e.target.value })} className={inp}><option value="">—</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
        <div className="min-w-[180px] flex-[2]"><label className="mb-1 block text-xs text-white/50">Tarea</label>
          <input data-testid="ops-task-title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} className={inp} /></div>
        <div className="min-w-[140px]"><label className="mb-1 block text-xs text-white/50">Fecha límite</label>
          <input data-testid="ops-task-due" type="date" value={f.due_date} onChange={(e) => setF({ ...f, due_date: e.target.value })} className={inp} /></div>
        {isSuper && <div className="min-w-[140px]"><label className="mb-1 block text-xs text-white/50">Asignar a</label>
          <select data-testid="ops-task-assignee" value={f.assignee_id} onChange={(e) => setF({ ...f, assignee_id: e.target.value })} className={inp}><option value="">—</option>{users.map((u) => <option key={u.id} value={u.id}>{u.name || u.email}</option>)}</select></div>}
        <button data-testid="ops-task-add" onClick={add} className="flex items-center gap-1.5 rounded-lg bg-[#AC3333] px-4 py-2 text-sm font-semibold text-white hover:bg-[#FF0505]"><Plus className="h-4 w-4" /> Añadir</button>
      </div>
      <div className="space-y-2">
        {rows.map((t) => (
          <div key={t.id} data-testid={`ops-task-${t.id}`} className="flex flex-wrap items-center gap-3 rounded-xl border border-white/10 bg-[#241010] p-3">
            <span className={`rounded-full px-2 py-0.5 text-[11px] ${badge[t.status] || badge.pendiente}`}>{t.status}</span>
            <span className="flex-1 text-sm text-white">{t.title}</span>
            <span className="text-xs text-white/40">{cname(t.client_id)}{t.due_date ? ` · ${t.due_date}` : ""}</span>
            <select data-testid={`ops-task-status-${t.id}`} value={t.status} onChange={(e) => setStatus(t, e.target.value)} className="rounded-lg border border-white/10 bg-white/5 px-2 py-1 text-xs text-white">{STATES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-white/40">Sin tareas.</p>}
      </div>
    </div>
  );
}
